import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { projectSettingsSpacePoliciesEntryPoint } from '@jira/spa-apps__project-settings-space-policies/src/projectSettingsSpacePoliciesEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectSettingsSoftwarePoliciesRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwarePoliciesRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

const projectSettingsSpacePoliciesPageEntryPoint = createPageEntryPoint({
	main: projectSettingsSpacePoliciesEntryPoint,
});

export const projectSettingsSoftwarePoliciesRouteEntry: Route = createEntry(
	projectSettingsSoftwarePoliciesRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.space-policies.jsw-tmp',
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',
		},

		entryPoint: () =>
			fg('frontier-guided-autonomy-space-settings')
				? projectSettingsSpacePoliciesPageEntryPoint
				: notFoundPageEntrypoint,
	}),
);
